import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    /* #956 (WCAG 2.4.7): o reset tirava o outline de tudo e nada o
       substituia. Anel escuro com folga branca, visivel no fundo claro e
       nos botoes laranja/verde; clique de mouse continua sem anel. */
    *:focus:not(:focus-visible) {
        outline: 0;
    }
    body *:focus-visible,
    body .Mui-focusVisible,
    body .MuiInputBase-root.Mui-focused {
        outline: 2px solid #222222;
        outline-offset: 2px;
        box-shadow: 0 0 0 2px #FFFFFF;
    }
    /* nos campos MUI o anel fica no contorno do campo, nao no input interno */
    body .MuiInputBase-input:focus-visible {
        outline: 0;
        box-shadow: none;
    }

    button {
        cursor: pointer;
      }

    .MuiDateRangeCalendar-root {
        & > div:first-child {
        display: none;
        }
    }
    .MuiPickersCalendarHeader-label {
        text-transform: capitalize;
    }

    .flex {
        display: flex;
    }

`;

export default GlobalStyle;
